import { v4 as uuid } from 'uuid';

import { Conjunction } from 'bones/utils/queryBuilder/constants';
import {
  DraftExpression,
  DraftFilter,
  DraftSubExpression,
  DraftTopExpression,
} from 'bones/utils/queryBuilder/types';

export const createNewFilter = (
  subject: DraftFilter['subject'] = null,
  invalid = false
): DraftFilter => ({
  id: uuid(),
  subject,
  operator: null,
  comparisonSubject: null,
  comparisonOperator: null,
  value: null,
  isInvalid: {
    subject: invalid,
    property: invalid,
    operator: invalid,
    comparisonSubject: false,
    comparisonProperty: false,
    value: false,
  },
  tooltip: {
    subject: '',
    property: '',
    comparisonSubject: '',
    comparisonProperty: '',
    value: '',
  },
});

export const createNewExpression = (
  subject: DraftFilter['subject'] = null,
  invalid = false
): DraftExpression => ({
  id: uuid(),
  filters: [createNewFilter(subject, invalid)],
});

export const createNewSubExpression = (
  subject: DraftFilter['subject'] = null,
  invalid = false
): DraftSubExpression => ({
  id: uuid(),
  conjunction: Conjunction.AND_NOT,
  expressions: [createNewExpression(subject, invalid)],
});

export const createNewTopExpression = (
  subject: DraftFilter['subject'] = null,
  invalid = false
): DraftTopExpression => ({
  conjunction: Conjunction.OR,
  expressions: [createNewSubExpression(subject, invalid)],
});
